// frontend/src/config/gauges/fsc.js
export const FSC_GAUGES = {
  maestro: {
    tProcesoEntrada: {
      title: "Temp Maestro Entrada",
      unit: "°C",
      min: 0,
      max: 30,
      ranges: [
        { min: 11, max: 14.99, color: "green" },
        { min: 8, max: 10.99, color: "yellow", openMin: true, openMax: true },  // (8,11)
        { min: 15, max: 19.99, color: "yellow", openMin: true, openMax: true }, // (14,20)
        { min: 0, max: 7.99, color: "red" },
        { min: 20, max: 50000, color: "red" },
      ],
    },
    tProcesoSalida: {
      title: "Temp Maestro Salida",
      unit: "°C",
      min: 0,
      max: 30,
      ranges: [
        { min: 7, max: 8.99, color: "green" },
        { min: 5, max: 6.99, color: "yellow", openMin: true, openMax: true },  
        { min: 9, max: 19.99, color: "yellow", openMin: true, openMax: true },  
        { min: 0, max: 4.99, color: "red" },
        { min: 20, max: 50000, color: "red" },
      ],
    },
  },

  modulo: {
    tEvapSal: {
      title: "Temp Evap Salida",
      unit: "°C",
      min: 0,
      max: 30,
      ranges: [
        { min: 7, max: 8.99, color: "green" },
        { min: 5, max: 6.99, color: "yellow", openMin: true, openMax: true },  
        { min: 9, max: 19.99, color: "yellow", openMin: true, openMax: true },  
        { min: 0, max: 4.99, color: "red" },
        { min: 20, max: 50000, color: "red" },
      ],
    },

    tDescarga: {
      title: "Temp Descarga",
      unit: "°C",
      min: 0,
      max: 120,
      ranges: [
        { min: 60, max: 79.99, color: "green" },
        { min: 50, max: 59.99, color: "yellow", openMin: true, openMax: true },
        { min: 80, max: 89.99, color: "yellow", openMin: true, openMax: true },
        { min: 0, max: 49.99, color: "red" },
        { min: 90, max: 50000, color: "red" },
      ],
    },

    pSuccion: {
      title: "Presión Succión",
      unit: "psi",
      min: 0,
      max: 80,
      ranges: [
        { min: 33, max: 39.99, color: "green" },
        { min: 29, max: 32.99, color: "yellow", openMin: true, openMax: true },
        { min: 40, max: 49.99, color: "yellow", openMin: true, openMax: true },
        { min: 0, max: 28.99, color: "red" },
        { min: 50, max: 20000, color: "red" },
      ],
    },

    pDescarga: {
      title: "Presión Descarga",
      unit: "psi",
      min: 0,
      max: 260,
      ranges: [
        { min: 170, max: 189.99, color: "green" },
        { min: 150, max: 169.99, color: "yellow", openMin: true, openMax: true },
        { min: 190, max: 209.99, color: "yellow", openMin: true, openMax: true },
        { min: 0, max: 149.99, color: "red" },
        { min: 210, max: 25000, color: "red" },
      ],
    },
  },
};
